export default () => ({
    standalone: false,
    async init() {
        this.standalone =
            window.matchMedia("(display-mode: standalone)").matches ||
            window.navigator.standalone === true;
    },
});
